import { Mail, Phone } from 'lucide-react'
import BackButton from '../../../components/common/BackButton'
import { useCompany } from '../../../context/CompanyContext'
import EditButton from '../../../components/common/EditButton'
import DeleteButton from '../../../components/common/DeleteButton'
import CompanyForm from '../CompanyForm'
import { useState } from 'react'
import CompanyDelete from './CompanyDelete'

const CompanyResume = () => {
    const [openEdit, setOpenEdit] = useState(false)
    const [openDelete, setOpenDelete] = useState(false)
    const { detail } = useCompany()
    if (!detail) return null
    const company = detail.company

    return (
        <>
            <div className='text-gray-800 dark:text-white/90 flex items-center justify-between'>
                <div className='space-y-1'>
                    <div className='flex items-center gap-2'>
                        <BackButton isIconOnly />
                        <h2 className='font-bold text-xl mr-1'>{company.name}</h2>
                    </div>
                    <div className='flex items-center gap-4'>
                        <div className='flex items-center gap-1'>
                            <Phone className='w-4 h-4' />
                            <p>{company.phone && company.phone != '' ? company.phone : 'Não informado'}</p>
                        </div>
                        <div className='flex items-center gap-1'>
                            <Mail className='w-4 h-4' />
                            <p>{company.email && company.email != '' ? company.email : 'Não informado'}</p>
                        </div>
                    </div>
                </div>

                <div className='flex items-center gap-1'>
                    <EditButton handleClick={() => setOpenEdit(true)} />
                    <DeleteButton handleClick={() => setOpenDelete(true)} />
                </div>
            </div>

            {/* Alterar */}
            <CompanyForm type='edit' open={openEdit} handleClose={() => setOpenEdit(false)} />

            {/* Excluir */}
            <CompanyDelete data={detail} open={openDelete} handleClose={() => setOpenDelete(false)} />
        </>
    )
}

export default CompanyResume
